import { LEAD_IDENTIFIERS } from "../../../../pages/leads-management/models/ILead";

export const getParameterOne = (lead: LEAD_IDENTIFIERS): string | undefined => {
  if (lead === LEAD_IDENTIFIERS.ALL_LEADS) {
    return "2,3,4";
  } else if (lead === LEAD_IDENTIFIERS.HOT_LEADS) {
    return "2";
  } else if (lead === LEAD_IDENTIFIERS.WARM_LEADS) {
    return "3";
  } else if (lead === LEAD_IDENTIFIERS.INTERESTED_LEADS) {
    return "4";
  }

  return undefined;
};
